import React, { useState, useEffect } from 'react'
import Grid from '@material-ui/core/Grid'
import { Field } from 'react-final-form'
import {
  parseTelefone,
  parseRg,
  parseCpf,
  parseCep
} from '../../../utils/Parse'
import {
  withStyles,
  Typography,
  Tooltip,
  LinearProgress,
  Button
} from '@material-ui/core'
import VerifiedUser from '@material-ui/icons/VerifiedUser'
import { Select, SimpleDialog, Snackbar } from 'elentari'
import {
  CustomTextField,
  CustomDatePicker
} from '../../../components/CustomDisabledFields'
import ValidacaoCnhCard from '../Requisicoes/ValidacoesCnh/ValidacaoCnhCard'
import PessoaFisicaCard from '../Requisicoes/PessoaFisica/PessoaFisicaCard'
import ValidacoesCnhRepository from '../Requisicoes/ValidacoesCnh/ValidacoesCnhRepository'
import motoristaRepository from './MotoristaRepository'
import StatusLabel from '../../../components/StatusLabel'
import { compareStrings, compareDates } from '../../../utils/Compare'
import CustomFileViewer from '../../../components/CustomFileViewer'
import { FieldArray } from 'react-final-form-arrays'
import { path, pathOr } from 'ramda'
import ViagensList from '../Viagens/ViagemList'
import InputAdornment from '@material-ui/core/InputAdornment'
import IconButton from '@material-ui/core/IconButton'
import StarsIcon from '@material-ui/icons/Stars'
import RefreshIcon from '@material-ui/icons/Refresh'
import ObservacaoField from '../../../components/ObservacaoField'
import EmpresaSelect from '../../Empresa/EmpresaSelect'
import motoristaFotoPadraoRepository from '../../MotoristaFotoPadrao/motoristaFotoPadraoRepository'
import MotoristaFotoPadraoAvatar from '../../MotoristaFotoPadrao/MotoristaFotoPadraoAvatar'
import DocumentValidator from '../../../components/DocumentValidator'
import { Alert } from '@material-ui/lab'
import ValidacaoFacialCard from '../Requisicoes/ValidacaoFacial/ValidacaoFacialCard'
import TermoEPoliticaCard from '../Requisicoes/TermoEPolitica/TermoEPoliticaCard'

const styles = theme => ({
  root: {
    padding: theme.spacing(6)
  },
  title: {
    marginTop: theme.spacing(5)
  },
  flex: {
    display: 'flex',
    justifyContent: 'center'
  },
  validationField: {
    display: 'flex'
  },
  importadoKMM: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(2)
  },
  btn: {
    marginRight: theme.spacing(1),
    width: '100%'
  }
})

const fieldComparation = (a, b, compare = compareStrings) => {
  if (a && b) return compare(a, b) ? 'success' : 'error'
  return 'error'
}

const dateComparation = (a, b) => fieldComparation(a, b, compareDates)

const allValid = values => values.filter(v => v.value !== 'success')

function MotoristaForm({
  classes,
  values,
  cannotUpdate,
  formChange,
  ...props
}) {
  const [validacoesCnh, setValidacoesCnh] = useState({})
  const [mensagem, setMensagem] = useState('')
  const [fetching, setFetching] = useState(false)
  const [fetchingFotoPadrao, setFetchingFotoPadrao] = useState(false)
  const [dialog, setDialog] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      const solicitacaoId = props.match.params.id

      const response = await ValidacoesCnhRepository.list({
        query: { solicitacaoId },
        paginate: { order: 'dataRequisicao DESC', limit: 1 }
      })

      if (response.ok && !!response.data.length) {
        setValidacoesCnh(response.data[0])
      }
    }
    fetchData()
  }, [props.match.params.id])

  const motorista = values.motorista
  const viagens = motorista && motorista.viagens
  let validationNomeMae,
    validationNomeMotorista,
    validationCnhValidade,
    validationCnhEmissao,
    validationCnhCategoria
  let validCnhData = []

  if (motorista) {
    validationNomeMae = fieldComparation(validacoesCnh.nomeMae, 'SIM')
    validationNomeMotorista = fieldComparation(
      validacoesCnh.nomeCondutor,
      'SIM'
    )
    validationCnhValidade = dateComparation(
      validacoesCnh.dataValidade,
      motorista.cnhValidade
    )
    validationCnhEmissao = dateComparation(
      validacoesCnh.dataEmissao,
      motorista.cnhEmissao
    )
    validationCnhCategoria = fieldComparation(
      validacoesCnh.categoria,
      motorista.cnhCategoria
    )

    validCnhData = allValid([
      { label: 'Nome Condutor', value: validationNomeMotorista },
      { label: 'Nome da Mãe', value: validationNomeMae },
      { label: 'Validade CNH', value: validationCnhValidade },
      { label: 'Emissão CNH', value: validationCnhEmissao },
      { label: 'Categoria CNH', value: validationCnhCategoria }
    ])
  }
  const warningCNHMessage = validCnhData.length
    ? `Campo(s) divergente(s): ${validCnhData.map(v => v.label).join(', ')}`
    : ''

  const handleChangeCpf = async () => {
    const cpfFormated = values.motorista && values.motorista.cpf
    if (cpfFormated) {
      setFetching(true)
      const cpf = cpfFormated.replace(/[^\d]/g, '')
      setMensagem('Buscando motorista')
      const response = await motoristaRepository.findKmmByCPFForSolicitacao(
        props.match.params.id,
        cpf
      )
      if (response.ok) {
        const motorista = response.data
        motorista.id = values.motorista ? values.motorista.id : undefined
        motorista.cnhImage = values.motorista
          ? values.motorista.cnhImage
          : undefined
        motorista.comprovanteEndereco = values.motorista
          ? values.motorista.comprovanteEndereco
          : undefined
        motorista.foto = values.motorista ? values.motorista.foto : undefined
        formChange(`motorista`, motorista)
        setMensagem(
          'Motorista encontrado com sucesso! Alterações devem ser feitas no KMM.'
        )
      } else {
        setMensagem(
          pathOr(
            'Falha de conexão com o servidor',
            ['data', 'error', 'message'],
            response
          )
        )
      }
    }
    setFetching(false)
  }

  const handleFotoPadraoClick = async () => {
    const cpfFormated = values.motorista && values.motorista.cpf
    if (cpfFormated) {
      setFetching(true)
      const cpf = cpfFormated.replace(/[^\d]/g, '')
      setMensagem('Atualizando foto padrão do motorista')
      const response = await motoristaFotoPadraoRepository.atualizarFoto(
        cpf,
        values.id
      )
      if (response.ok) {
        setMensagem('Foto padrão atualizada com sucesso')
        setFetchingFotoPadrao(!fetchingFotoPadrao)
      } else {
        setMensagem('Falha ao tentar atualizar a foto')
      }
    }
    setDialog(false)
    setFetching(false)
  }

  return (
    <div className={classes.root}>
      {fetching && <LinearProgress />}
      <Grid container spacing={3}>
        {/* Motorista */}
        <Grid item xs={12}>
          <Grid container spacing={8}>
            {/* Half 0 */}
            <Grid item xs={12} md={6}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography variant="h6" gutterBottom>
                    Motorista
                    {path(['motorista', 'importadoKMM'], values) && (
                      <Tooltip title="Usuário importado KMM">
                        <VerifiedUser
                          color="disabled"
                          fontSize="small"
                          className={classes.importadoKMM}
                        />
                      </Tooltip>
                    )}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Field
                    fullWidth
                    component={CustomTextField}
                    format={parseCpf}
                    disabled
                    label="CPF"
                    name="motorista.cpf"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            edge="end"
                            disabled={cannotUpdate}
                            onClick={handleChangeCpf}
                          >
                            <RefreshIcon />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <div className={classes.validationField}>
                    <Field
                      fullWidth
                      component={CustomTextField}
                      disabled
                      label="Nome"
                      name="motorista.nome"
                    />
                    <StatusLabel state={validationNomeMotorista} />
                  </div>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Field
                    fullWidth
                    component={CustomTextField}
                    format={parseRg}
                    disabled
                    label="RG"
                    name="motorista.rg"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Field
                    fullWidth
                    component={CustomTextField}
                    disabled
                    label="Emissor"
                    name="motorista.rgEmissor"
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <Field
                    fullWidth
                    component={CustomDatePicker}
                    disabled
                    label="Data Emissão"
                    name="motorista.rgData"
                    disableFuture
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Field
                    fullWidth
                    component={CustomTextField}
                    disabled
                    label="Sexo"
                    name="motorista.sexo"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Field
                    fullWidth
                    component={CustomDatePicker}
                    disabled
                    label="Data nascimento"
                    name="motorista.dataNascimento"
                    disableFuture
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Field
                    fullWidth
                    component={CustomTextField}
                    disabled
                    label="Naturalidade"
                    name="motorista.naturalidade"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Field
                    fullWidth
                    component={CustomTextField}
                    disabled
                    label="UF"
                    name="motorista.naturalidadeUf"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    fullWidth
                    component={CustomTextField}
                    disabled
                    label="Estado Civil"
                    name="motorista.estadoCivil"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    fullWidth
                    component={CustomTextField}
                    disabled
                    label="PIS/PASEP"
                    name="motorista.pisPasep"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <div className={classes.validationField}>
                    <Field
                      fullWidth
                      component={CustomTextField}
                      disabled
                      label="Mãe"
                      name="motorista.nomeMae"
                    />
                    <StatusLabel state={validationNomeMae} />
                  </div>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Field
                    fullWidth
                    component={CustomTextField}
                    disabled
                    format={parseCpf}
                    label="CPF Mãe"
                    name="motorista.cpfMae"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Field
                    fullWidth
                    component={CustomTextField}
                    disabled
                    label="Pai"
                    name="motorista.nomePai"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Field
                    fullWidth
                    component={CustomTextField}
                    format={parseCpf}
                    disabled
                    label="CPF Pai"
                    name="motorista.cpfPai"
                  />
                </Grid>
              </Grid>
            </Grid>
            {/* Half 1 */}
            <Grid item xs={12} md={6}>
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                spacing={3}
              >
                <Grid item xs={12}>
                  <MotoristaFotoPadraoAvatar
                    cpf={values.motorista && values.motorista.cpf}
                    grande
                    fetchingFotoPadrao={fetchingFotoPadrao}
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomFileViewer
                    newTab
                    label="Foto do Rosto"
                    filePath={motorista && motorista.foto}
                  />
                </Grid>
                <Grid item xs={12}>
                  <DocumentValidator
                    legend="A foto está legível?"
                    name="motorista.fotoLegivel"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    fullWidth
                    variant="outlined"
                    color="primary"
                    className={classes.btn}
                    startIcon={<StarsIcon />}
                    onClick={() => setDialog(true)}
                    disabled={cannotUpdate}
                  >
                    Definir como Padrão
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <ValidacaoFacialCard
                    match={props.match}
                    cpf={motorista && motorista.cpf}
                    disabled={cannotUpdate}
                  />
                </Grid>
                <Grid item xs={12}>
                  <PessoaFisicaCard
                    match={props.match}
                    cpf={motorista && motorista.cpf}
                    disabled={cannotUpdate}
                    validateFieldName="motorista.pessoaFisicaValida"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {/* CNH */}
        <Grid item xs={12}>
          <Grid container spacing={8}>
            {/* Half 0 */}
            <Grid item xs={12} md={6}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography
                    className={classes.title}
                    variant="h6"
                    gutterBottom
                  >
                    CNH
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    fullWidth
                    component={CustomTextField}
                    disabled
                    label="Número"
                    name="motorista.cnhNumero"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    fullWidth
                    component={CustomTextField}
                    disabled
                    label="Renach"
                    name="motorista.cnhRenach"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <div className={classes.validationField}>
                    <Field
                      fullWidth
                      component={CustomTextField}
                      disabled
                      label="Categoria"
                      name="motorista.cnhCategoria"
                    />
                    <StatusLabel state={validationCnhCategoria} />
                  </div>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Field
                    fullWidth
                    component={CustomTextField}
                    disabled
                    label="UF"
                    name="motorista.cnhUf"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Field
                    fullWidth
                    component={CustomTextField}
                    disabled
                    label="Emissor"
                    name="motorista.cnhEmissor"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Field
                    fullWidth
                    component={CustomDatePicker}
                    disabled
                    label="Primeira Emissão"
                    name="motorista.cnhPrimeiraEmissao"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <div className={classes.validationField}>
                    <Field
                      fullWidth
                      component={CustomDatePicker}
                      disabled
                      label="Data Emissão"
                      name="motorista.cnhEmissao"
                      disableFuture
                    />
                    <StatusLabel state={validationCnhEmissao} />
                  </div>
                </Grid>
                <Grid item xs={12} md={6}>
                  <div className={classes.validationField}>
                    <Field
                      fullWidth
                      component={CustomDatePicker}
                      disabled
                      label="Validade"
                      name="motorista.cnhValidade"
                    />
                    <StatusLabel state={validationCnhValidade} />
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <CustomFileViewer
                    newTab
                    label="CNH"
                    filePath={motorista && motorista.cnhImage}
                  />
                </Grid>
                <Grid item xs={12}>
                  <DocumentValidator name="motorista.cnhLegivel" />
                </Grid>
              </Grid>
            </Grid>
            {/* Half 1 */}
            <Grid item xs={12} md={6}>
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                spacing={3}
              >
                <Grid item xs={12}>
                  <ValidacaoCnhCard
                    match={props.match}
                    cpf={motorista && motorista.cpf}
                    numRegistro={motorista && motorista.cnhNumero}
                    numSeguranca={motorista && motorista.cnhRenach}
                    nome={motorista && motorista.nome}
                    nomeMae={motorista && motorista.nomeMae}
                    dataValidade={motorista && motorista.cnhValidade}
                    dataEmissao={motorista && motorista.cnhEmissao}
                    categoria={motorista && motorista.cnhCategoria}
                    disabled={cannotUpdate}
                    validData={validCnhData.length === 0}
                    warningMessage={warningCNHMessage}
                    validateFieldName="motorista.cnhValida"
                  />
                </Grid>
                {/* Termo e Contrato */}
                <Grid item xs={12}>
                  {motorista && <TermoEPoliticaCard cpf={motorista.cpf} />}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Viagens */}
        <Grid item xs={12}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography className={classes.title} variant="h6" gutterBottom>
                Viagens
              </Typography>
            </Grid>
            {motorista &&
              (motorista.quantidadeViagens ||
                motorista.destaquesViagens ||
                motorista.quantidadeUltimasViagens) && (
                <Grid item xs={12}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={4}>
                      <Field
                        fullWidth
                        component={CustomTextField}
                        disabled
                        label="Quantidade G10"
                        name="motorista.quantidadeViagens"
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Field
                        fullWidth
                        component={CustomTextField}
                        disabled
                        label="Destaques G10"
                        name="motorista.destaquesViagens"
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Field
                        fullWidth
                        component={CustomTextField}
                        disabled
                        label="Quantidade Últimas G10"
                        name="motorista.quantidadeUltimasViagens"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )}
            {motorista &&
              (motorista.quantidadeViagensTP ||
                motorista.destaquesViagensTP ||
                motorista.quantidadeUltimasViagensTP) && (
                <Grid item xs={12}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={4}>
                      <Field
                        fullWidth
                        component={CustomTextField}
                        disabled
                        label="Quantidade TP"
                        name="motorista.quantidadeViagensTP"
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Field
                        fullWidth
                        component={CustomTextField}
                        disabled
                        label="Destaques TP"
                        name="motorista.destaquesViagensTP"
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Field
                        fullWidth
                        component={CustomTextField}
                        disabled
                        label="Quantidade Últimas TP"
                        name="motorista.quantidadeUltimasViagensTP"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )}
            <Grid item xs={12}>
              <ViagensList viagens={viagens} detalhesMotorista />
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography className={classes.title} variant="h6" gutterBottom>
                Sinistros
              </Typography>
            </Grid>
            <FieldArray name="motorista.sinistros">
              {({ fields }) =>
                fields.length ? (
                  fields
                    .map((name, index) => (
                      <Grid item xs={12} key={name}>
                        <Grid container spacing={3}>
                          <Grid item xs={12}>
                            <Typography>{index + 1}º Sinistro</Typography>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <Field
                              fullWidth
                              component={CustomTextField}
                              disabled
                              label="Evento"
                              name={`${name}.evento`}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <EmpresaSelect
                              disabled
                              name={`${name}.empresaId`}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <Field
                              fullWidth
                              component={CustomTextField}
                              disabled
                              label="Ocorrência"
                              multiline
                              rows={5}
                              name={`${name}.ocorrencia`}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    ))
                    .filter((_, i) => i < 5)
                ) : (
                  <Grid item xs={12}>
                    <Typography>Não foram encontrados sinistros</Typography>
                  </Grid>
                )
              }
            </FieldArray>
          </Grid>
        </Grid>
        {/* Endereço */}
        <Grid item xs={12}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography className={classes.title} variant="h6" gutterBottom>
                Endereço
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Field
                fullWidth
                component={CustomTextField}
                disabled
                format={parseCep}
                label="CEP"
                name="motorista.cep"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Field
                fullWidth
                component={CustomTextField}
                disabled
                label="Estado"
                name="motorista.estado"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Field
                fullWidth
                component={CustomTextField}
                disabled
                label="Cidade"
                name="motorista.cidade"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Field
                fullWidth
                component={CustomTextField}
                disabled
                label="Bairro"
                name="motorista.bairro"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Field
                fullWidth
                component={CustomTextField}
                disabled
                label="Logradouro"
                name="motorista.logradouro"
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <Field
                fullWidth
                component={CustomTextField}
                disabled
                label="Número"
                name="motorista.numero"
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <Field
                fullWidth
                component={CustomTextField}
                disabled
                label="Complemento"
                name="motorista.complemento"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomFileViewer
                newTab
                label="Comprovante de Endereco"
                filePath={motorista && motorista.comprovanteEndereco}
              />
            </Grid>
            {motorista && motorista.comprovanteEndereco && (
              <Grid item xs={12}>
                <DocumentValidator
                  disabled={cannotUpdate}
                  legend="O comprovante está correto?"
                  name="motorista.comprovanteValido"
                />
              </Grid>
            )}
          </Grid>
        </Grid>
        {/* Contato */}
        <Grid item xs={12}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Typography className={classes.title} variant="h6" gutterBottom>
                Contato
              </Typography>
              {motorista && motorista.alertaTelefone && (
                <Alert variant="outlined" severity="warning">
                  Telefone Diferente do último cadastrado{' '}
                  {motorista.ultimoTelefone}
                </Alert>
              )}
            </Grid>
            <Grid item xs={12} md={8} />
            <Grid item xs={12} md={6}>
              <Field
                fullWidth
                component={CustomTextField}
                format={parseTelefone}
                label="Telefone"
                name="motorista.telefone"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Field
                fullWidth
                hideEmpty
                component={Select}
                options={[
                  { label: 'Sim', value: true },
                  { label: 'Não', value: false }
                ]}
                label="Contato com Motorista Realizado"
                name="contatoMotorista"
              />
            </Grid>
            <ObservacaoField
              value={values.observacaoContatoMotorista}
              title="Observações do Contato com Motorista"
              placeholder="Escreva aqui observações sobre as informações do contato com o motorista"
              name="novaObservacaoContatoMotorista"
              disabled={cannotUpdate}
            />
          </Grid>
        </Grid>
        <ObservacaoField
          value={values.observacaoMotorista}
          title="Observações Motorista"
          placeholder="Escreva aqui observações sobre as informações do motorista"
          name="novaObservacaoMotorista"
          disabled={cannotUpdate}
        />
      </Grid>
      <Snackbar message={mensagem} onClose={() => setMensagem('')} />
      <SimpleDialog
        open={dialog}
        buttonLabel="Não"
        handleClose={() => setDialog(false)}
        primaryAction={handleFotoPadraoClick}
        title="Deseja definir a foto dessa solicitação como a padrão do motorista?"
        primaryActionButtonLabel="Sim"
      />
    </div>
  )
}

export default withStyles(styles)(MotoristaForm)
